import React, { useMemo } from "react";

export default function AlertItemComponent(props) {
  const { id, keyword, experience, schedule, job_type } = props.item;
  const { handleRemove, jobTypes } = props;

  const frequency = useMemo(() => {
    return {
      1: "daily",
      2: "Weekly",
      3: "Monthly",
    };
  }, []);

  return (
    <div className="alerts-content">
      <div className="row">
        <div className="col-md-4">
          <p>{keyword ?? "N/A"}</p>
        </div>
        <div className="col-md-3">
          <p>
            <span className="full-time">{jobTypes[job_type] ?? "N/A"}</span>
          </p>
        </div>
        <div className="col-md-2">
          <p>{experience + " Years"}</p>
        </div>
        <div className="col-md-2">
          <p>{frequency[schedule]}</p>
        </div>
        <div className="col-md-1 d-flex align-items-center h3">
          <i
          style={{cursor:'pointer'}}
            onClick={() => handleRemove(id)}
            title="Remove Job Alert"
            className="fa fa-trash text-danger fs-3"
          ></i>
        </div>
      </div>
    </div>
  );
}
